import { FormField } from "@ui/components/Form";
import { OtpInput } from "@ui/components/OtpInput";
import { Txt } from "@ui/components/Txt";
import { useTranslations } from "@ui/providers/useTranslations";
import { restrictToAlphaNumericKey } from "@ui/utils/restrictToAlphaNumericKey";
import classNames from "classnames";

import { UiWarningIcon } from "@jti/brand-icons/ui-warning";

import styles from "./OtpInputSection.module.scss";

export interface OtpInputSectionProps {
  fieldName: (name: string) => string;
  dataTestId: string;
  inputStyle: string;
  isInputNum: boolean;
  autocompleteType: string;
  isAttemptError: boolean;
  attemptsNum: number;
  isDisabled: boolean;
}

const CONSTANTS = {
  OTP_LENGTH: 4,
  ERROR_STYLE: {
    // TODO: refactor OtpInput to new design system
    border: "2px solid var(--des-color-stroke-error)",
  },
} as const;

export const OtpInputSection = ({
  fieldName,
  dataTestId,
  inputStyle,
  isInputNum,
  autocompleteType,
  isAttemptError,
  attemptsNum,
  isDisabled,
}: OtpInputSectionProps) => {
  const { __ } = useTranslations();

  return (
    <div className={styles.otpInputSectionContainer} onKeyDown={restrictToAlphaNumericKey}>
      <Txt className={styles.otp}>{__("profile.phone_update_page.otp")}</Txt>
      <FormField
        name={fieldName("phone_validation_code")}
        render={({ field }) => (
          <OtpInput
            {...field}
            data-testid={dataTestId}
            inputStyle={classNames(inputStyle, styles.inputStyle)}
            isInputNum={isInputNum}
            autocompleteType={autocompleteType}
            hasErrored={isAttemptError}
            errorStyle={CONSTANTS.ERROR_STYLE}
            isDisabled={isDisabled}
            containerStyle={styles.otpInputContainer}
          />
        )}
        validation={{
          required: __("auth.registration.otp.validation.field_required"),
          minLength: {
            value: CONSTANTS.OTP_LENGTH,
            message: __("auth.registration.otp.validation.field_min_length"),
          },
        }}
      />
      {isAttemptError && (
        <div className={styles.errorAttempt}>
          <UiWarningIcon className={styles.errorIcon} />
          <span>{__("auth.login.sms_verify.attempts_left", [attemptsNum])}</span>
        </div>
      )}
    </div>
  );
};
